// extracted by mini-css-extract-plugin
export default {"container":"LuckyLettersPage_container__NkL9f","content":"LuckyLettersPage_content__rPrY-","letters":"LuckyLettersPage_letters__zkZxI"};